import { formatPhone } from './phone'
const numberFormat = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' })
export const displayPrice = (price: number | string) => {
  const number = typeof price === 'string' ? Number(price) : price
  return numberFormat.format(number)
}

export const toStringNumber = (number: number) => `${Number(number.toFixed(2))}`

export const toPhoneString = (phone: string, prefix?: string | null) => {
  if (!phone) return phone
  if (prefix) return formatPhone(phone, prefix)

  const digits = phone.replace(/\D/g, '')
  if (digits.length < 9) return phone

  const local = digits.slice(-9).replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
  const code = digits.slice(0, -9).replace(/^00/, '')

  return code ? `+${code} ${local}` : local
}

export const getFormattedLogin = (value: string) => {
  if (/^\d+$/.test(value)) {
    return value.replace(/(\d{3})(?=\d)/g, '$1 ')
  }

  return value
}